import store from '../store/store';
import { assertNever } from 'owa-assert';
import SpamScenarioId from '../store/schema/SpamScenarioId';
import {
    getOptionsForFeature,
    AmpDeveloperOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';

/**
 * Returns a subset of mailbox junk email configuration object which is observable depending on
 * which scenarioId is provided. Ex: Safe senders, Safe domains etc.
 */
export function getMailboxJunkEmailListByScenarioId(scenarioId: SpamScenarioId): string[] {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return store.mailboxJunkEmailConfiguration.BlockedSendersAndDomains;
        case SpamScenarioId.SafeSendersAndDomains:
            return store.mailboxJunkEmailConfiguration.TrustedSendersAndDomains;
        case SpamScenarioId.SafeMailingLists:
            return store.mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains;
        case SpamScenarioId.AllowedDynamicEmailSenders:
            return getOptionsForFeature<AmpDeveloperOptions>(OwsOptionsFeatureType.AmpDeveloper)
                .allowedSender;
        default:
            return assertNever(scenarioId);
    }
}

export function getMailboxJunkEmailIsTrustedListsOnly(): boolean {
    return store.mailboxJunkEmailConfiguration.TrustedListsOnly;
}

export function getMailboxJunkEmailIsContactsTrusted(): boolean {
    return store.mailboxJunkEmailConfiguration.ContactsTrusted;
}

export function getStoredMailboxJunkEmailConfiguration(): MailboxJunkEmailConfigurationOptions {
    return store.mailboxJunkEmailConfiguration;
}
